/*
  Product page behaviour for the House of Raaga layout:
  size stock note · pincode check · sticky buy bar · Complete the look · Recently viewed.
*/
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var routes = window.routes || {};

  var store = {
    get: function (k, d) {
      try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; }
    },
    set: function (k, v) {
      try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
    }
  };

  function formatMoney(cents, format) {
    var n = Number(cents) || 0;
    var fmt = format || '{{amount}}';
    function group(num, dec, thou, dot) {
      var fixed = (num / 100).toFixed(dec);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + dot + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        default: return group(n, 2, ',', '.');
      }
    });
  }


  var cfg = window.pdpConfig || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- toast (mockup .toast) */
  var toastTimer;
  function toast(msg, imgSrc, title) {
    var t = document.getElementById('PdpToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'PdpToast';
      t.className = 'pdp-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = '';
    if (imgSrc) {
      var im = document.createElement('img');
      im.src = imgSrc; im.width = 38; im.height = 48; im.alt = '';
      t.appendChild(im);
    } else {
      t.insertAdjacentHTML('beforeend', '<svg class="pdp-toast__ok" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>');
    }
    var box = document.createElement('div');
    if (title) { var b = document.createElement('b'); b.textContent = title; box.appendChild(b); }
    var sp = document.createElement('span'); sp.textContent = msg; box.appendChild(sp);
    t.appendChild(box);
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2800);
  }
  window.pdpToast = toast;

  /* ---------------------------------------------------------------- fly to cart + bump */
  function cartButton() { return document.getElementById('cart-icon-bubble'); }

  function bump() {
    var c = cartButton();
    if (!c) return;
    c.classList.remove('pdp-bump');
    void c.offsetWidth;
    c.classList.add('pdp-bump');
  }

  function fly(fromEl, src) {
    var cart = cartButton();
    if (cfg.fly === false || reduceMotion || !fromEl || !cart || !src || !fromEl.animate) return;
    var a = fromEl.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var ghost = document.createElement('img');
    ghost.src = src;
    ghost.alt = '';
    ghost.className = 'pdp-fly';
    ghost.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
    document.body.appendChild(ghost);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 },
      { transform: 'translate(' + dx * 0.52 + 'px,' + (dy * 0.52 - Math.min(150, a.height * 0.75)) + 'px) scale(.5)', opacity: 0.96, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: 0, offset: 1 }
    ], { duration: 820, easing: 'cubic-bezier(.45,.05,.35,1)', fill: 'forwards' });
    anim.onfinish = anim.oncancel = function () { ghost.remove(); };
  }

  /* refresh the bag count (and the drawer contents) without opening the drawer */
  function refreshCart() {
    return fetch(root + '?sections=cart-icon-bubble,cart-drawer')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (sections) {
        var parse = function (html, sel) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
          return el ? el.innerHTML : null;
        };
        var bubble = cartButton();
        if (bubble && sections['cart-icon-bubble']) {
          var inner = parse(sections['cart-icon-bubble'], '.shopify-section');
          if (inner !== null) bubble.innerHTML = inner;
        }
        var drawer = document.querySelector('#CartDrawer');
        if (drawer && sections['cart-drawer']) {
          var d = parse(sections['cart-drawer'], '#CartDrawer');
          if (d !== null) drawer.innerHTML = d;
          var host = document.querySelector('cart-drawer');
          if (host) host.classList.remove('is-empty');
        }
      }).catch(function () {});
  }

  /* open the theme's cart drawer, swapping in fresh markup when the add call returned it */
  function openCartDrawer(html) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return false;
    if (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
      var live = document.querySelector('#CartDrawer');
      if (parsed && live) live.innerHTML = parsed.innerHTML;
    }
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    drawer.classList.remove('is-empty');
    drawer.open(document.getElementById('cart-icon-bubble'));
    return true;
  }

  /* whole-rupee display, like the mockup (₹1,274 not ₹1,274.15) */
  function formatWhole(cents, format) {
    return formatMoney(Math.round((Number(cents) || 0) / 100) * 100, (format || '{{amount}}').replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}'));
  }

  function mainForm() {
    return document.querySelector('.main-product-template .product--thumbnail_slider_left form[data-type="add-to-cart-form"]') ||
      document.querySelector('.main-product-template form[action*="/cart/add"]');
  }

  function currentVariantId() {
    var f = mainForm();
    var input = f && f.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  /* ---------------------------------------------------------------- size note */
  function sizeNote(note) {
    var fieldset = note.closest('fieldset');
    if (!fieldset) return;
    var inputs = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    var out = inputs.filter(function (i) { return i.getAttribute('data-pdp-available') === 'false'; }).map(function (i) { return i.value; });

    var t = function (key, fallback) { var v = note.getAttribute('data-note-' + key); return v === null ? fallback : v; };
    note.classList.remove('warn');
    if (out.length === inputs.length) {
      note.textContent = t('none', 'Out of stock in every size.');
      note.classList.add('warn');
    } else if (!note.dataset.pdpTouched) {
      if (out.length) {
        note.textContent = t('some', 'Size [sizes] is out — everything else ships today.').replace('[sizes]', out.join(', '));
        note.classList.add('warn');
      } else {
        note.textContent = t('all', 'Every size in stock · ships today');
      }
    } else if (checked && checked.getAttribute('data-pdp-available') === 'false') {
      note.textContent = t('selected-out', 'Size [size] is out of stock').replace('[size]', checked.value);
      note.classList.add('warn');
    } else if (checked) {
      note.textContent = t('selected', 'Size [size] selected · ships today').replace('[size]', checked.value);
    }
  }

  function initSizeNotes(scope) {
    (scope || document).querySelectorAll('[data-pdp-size-note]').forEach(function (note) {
      if (note.dataset.pdpBound) return;
      note.dataset.pdpBound = 'true';
      var fieldset = note.closest('fieldset');
      if (fieldset) fieldset.addEventListener('change', function () { note.dataset.pdpTouched = 'true'; sizeNote(note); });
      sizeNote(note);
    });
  }

  /* ---------------------------------------------------------------- size guide panel
     Opening and closing work without JavaScript (:target). This only stops the page
     jumping to the anchor and adds Escape. */
  function chartPanel() { return document.querySelector('.main-product-template .pdp-scrim'); }

  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-pdp-chart-open]');
    var close = e.target.closest && e.target.closest('[data-pdp-chart-close], .pdp-scrim__back');
    var panel = chartPanel();
    if (!panel) return;
    if (open) {
      e.preventDefault();
      panel.classList.add('on');
      document.documentElement.style.overflow = 'hidden';
      var x = panel.querySelector('[data-pdp-chart-close]'); if (x) x.focus();
    } else if (close) {
      e.preventDefault();
      panel.classList.remove('on');
      document.documentElement.style.overflow = '';
      var opener = document.querySelector('[data-pdp-chart-open]'); if (opener) opener.focus();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = chartPanel();
    if (!panel) return;
    if (panel.classList.contains('on') || location.hash === '#' + panel.id) {
      panel.classList.remove('on');
      document.documentElement.style.overflow = '';
      if (location.hash === '#' + panel.id) history.replaceState(null, '', location.pathname + location.search);
      var opener = document.querySelector('[data-pdp-chart-open]'); if (opener) opener.focus();
    }
  });

  /* ---------------------------------------------------------------- size pills: always selectable
     The label's own behaviour normally checks the radio. This is a safety net for cases where
     an overlay or another script swallows that click. */
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.main-product-template fieldset.option-name-size .varient-class label');
    if (!label) return;
    var input = label.previousElementSibling;
    if (!input || input.type !== 'radio') input = document.getElementById(label.getAttribute('for'));
    if (!input || input.checked) return;
    setTimeout(function () {
      if (input.checked) return; // the label already did it
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 0);
  });

  /* ---------------------------------------------------------------- pincode */
  function initPin(scope) {
    (scope || document).querySelectorAll('[data-pdp-pin]').forEach(function (box) {
      if (box.dataset.pdpBound) return;
      box.dataset.pdpBound = 'true';
      var input = box.querySelector('.pdp-pin__in');
      var go = box.querySelector('.pdp-pin__go');
      var out = box.querySelector('.pdp-pin__out');
      var rulesEl = box.querySelector('[data-pdp-pin-rules]');
      if (!input || !go || !out || !rulesEl) return;

      var rules = [];
      try { rules = JSON.parse(rulesEl.textContent) || []; } catch (e) { rules = []; }
      if (!Array.isArray(rules)) rules = [];

      function check() {
        var v = String(input.value || '').trim();
        out.className = 'pdp-pin__out';
        if (!/^[1-9][0-9]{5}$/.test(v)) {
          out.classList.add('bad');
          out.textContent = 'Enter a valid 6-digit pincode';
          return;
        }
        var hit = null;
        rules.forEach(function (r) {
          var p = String(r && r.prefix || '');
          if (p && v.indexOf(p) === 0 && (!hit || p.length > String(hit.prefix).length)) hit = r;
        });
        var fbDays = Number(box.getAttribute('data-fallback-days'));
        if (!hit && fbDays) hit = { city: v, days: fbDays, cod: box.getAttribute('data-fallback-cod') !== 'false' };
        if (!hit) {
          out.textContent = out.getAttribute('data-unmatched') || '';
          return;
        }
        store.set('pdp-pin', v);
        var d = new Date();
        d.setDate(d.getDate() + (Number(hit.days) || 5));
        var by = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });

        out.classList.add('ok');
        out.textContent = '';
        out.appendChild(document.createTextNode('Delivering to '));
        var city = document.createElement('b'); city.textContent = hit.city || v; out.appendChild(city);
        out.appendChild(document.createTextNode(' · get it by '));
        var date = document.createElement('b'); date.textContent = by; out.appendChild(date);
        out.appendChild(document.createTextNode(' · '));
        var cod = document.createElement('b');
        cod.className = hit.cod === false ? 'no' : 'yes';
        cod.textContent = hit.cod === false ? 'Prepaid only on this pincode' : 'Cash on delivery available';
        out.appendChild(cod);
      }

      input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, ''); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
      go.addEventListener('click', check);

      var saved = store.get('pdp-pin', '');
      if (saved) { input.value = saved; check(); }
    });
  }

  /* ---------------------------------------------------------------- sticky buy bar */
  function initStick() {
    var bar = document.querySelector('[data-pdp-stick]');
    var grid = document.querySelector('.main-product-template .main-product_info');
    if (!bar || !grid || bar.dataset.pdpBound) return;
    bar.dataset.pdpBound = 'true';

    // mockup: a sentinel after the product grid; the bar is up whenever it is out of view
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    function setOn(on) {
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }

    if ('IntersectionObserver' in window) {
      if (bar.getAttribute('data-show') === 'scroll') {
        // up only once the main buttons have scrolled above the viewport
        var ctas = document.querySelector('.main-product-template .product-form__buttons');
        if (ctas) new IntersectionObserver(function (entries) {
          var e = entries[0];
          setOn(!e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(ctas);
      } else {
        new IntersectionObserver(function (entries) { setOn(!entries[0].isIntersecting); },
          { rootMargin: '-80px 0px 0px 0px' }).observe(sentinel);
      }
    }

    var priceEl = bar.querySelector('[data-pdp-stick-price]');
    function syncPrice() {
      var p = document.querySelector('.main-product-template .price-wrapper .price .price-item--last, .main-product-template .price-wrapper .price .price-item--regular');
      var submit = mainForm() && mainForm().querySelector('.product-form__submit');
      if (p && priceEl) {
        var available = !(submit && submit.hasAttribute('disabled'));
        priceEl.textContent = p.textContent.trim().replace(/[.,]00(?=\D*$)/, '') + ' · ' +
          (available ? (priceEl.getAttribute('data-in') || 'in stock') : (priceEl.getAttribute('data-out') || 'sold out'));
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-radios, variant-selects')) setTimeout(syncPrice, 700);
    });

    var addBtn = bar.querySelector('[data-pdp-stick-add]');
    var buyBtn = bar.querySelector('[data-pdp-stick-buy]');
    if (addBtn) addBtn.addEventListener('click', function () {
      var submit = mainForm() && mainForm().querySelector('.product-form__submit');
      if (submit) submit.click();
    });
    if (buyBtn) buyBtn.addEventListener('click', function () {
      var buy = document.querySelector('.main-product-template [data-pdp-buy-now], .main-product-template .shopify-payment-button__button');
      if (buy) { buy.click(); return; }
      var submit = mainForm() && mainForm().querySelector('.product-form__submit');
      if (submit) submit.click();
    });
  }

  /* ---------------------------------------------------------------- complete the look */
  function initLook() {
    var sec = document.querySelector('[data-pdp-look]');
    if (!sec || sec.dataset.pdpBound) return;
    sec.dataset.pdpBound = 'true';

    var grid = sec.querySelector('[data-pdp-look-grid]');
    var totalEl = sec.querySelector('[data-pdp-look-total]');
    var addBtn = sec.querySelector('[data-pdp-look-add]');
    var pct = Number(sec.getAttribute('data-pct')) || 0;
    var max = Number(sec.getAttribute('data-max')) || 3;
    var fmt = sec.getAttribute('data-money-format');
    var words = ['', 'one', 'two', 'three', 'four'];

    function load(intent) {
      var url = sec.getAttribute('data-url') + (intent ? '&intent=' + intent : '');
      return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('[data-pdp-look-items]');
        return box ? Array.prototype.slice.call(box.children) : [];
      }).catch(function () { return []; });
    }

    function fallback() {
      var tpl = sec.querySelector('template[data-pdp-look-fallback]');
      return tpl ? Array.prototype.slice.call(tpl.content.children) : [];
    }

    function setup(items) {
      (items || []).forEach(function (a) { grid.appendChild(document.importNode(a, true)); });

      var cards = grid.querySelectorAll('[data-price]');
      var n = cards.length;
      var total = 0;
      cards.forEach(function (c) { total += Number(c.getAttribute('data-price')) || 0; });
      var word = words[n] || String(n);
      var label = 'All ' + word + ': ';

      totalEl.textContent = '';
      totalEl.appendChild(document.createTextNode(label));
      if (pct > 0) {
        var bundle = Math.round(total / 100 * (100 - pct) / 100 / 10) * 10 * 100;
        var s1 = document.createElement('s'); s1.textContent = formatWhole(total, fmt);
        var b = document.createElement('b'); b.textContent = formatWhole(bundle, fmt);
        var i = document.createElement('i'); i.textContent = 'save ' + formatWhole(total - bundle, fmt);
        totalEl.appendChild(s1); totalEl.appendChild(document.createTextNode(' ')); totalEl.appendChild(b); totalEl.appendChild(i);
      } else {
        var t = document.createElement('b'); t.textContent = formatWhole(total, fmt);
        totalEl.appendChild(t);
      }
      if (n !== 4) addBtn.textContent = 'Add all ' + word;

      addBtn.addEventListener('click', function () {
        var ids = grid.querySelector('.is-this') ? [currentVariantId()] : [];
        grid.querySelectorAll('[data-look-variant]').forEach(function (c) { ids.push(c.getAttribute('data-look-variant')); });
        ids = ids.filter(Boolean);
        if (!ids.length) return;
        addBtn.disabled = true;
        fetch((routes.cart_add_url || root + 'cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }),
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function (data) {
          var sections = (data && data.sections) || {};
          var bubble = cartButton();
          if (bubble && sections['cart-icon-bubble']) {
            var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (doc) bubble.innerHTML = doc.innerHTML;
          }
          addBtn.disabled = false;
          setTimeout(bump, reduceMotion ? 0 : 400);
          // the drawer is the theme's own; only fall back to the cart page when there isn't one
          if (!openCartDrawer(sections['cart-drawer'])) window.location.href = routes.cart_url || root + 'cart';
        }).catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Could not add — try again';
        });
      });

      sec.hidden = false;
    }

    // pieces chosen in the theme editor are already in the page
    if (sec.getAttribute('data-manual')) { setup([]); return; }

    load('complementary').then(function (items) {
      return items.length ? items : load('');
    }).then(function (items) {
      return items.length ? items : fallback();
    }).then(function (items) {
      items = items.slice(0, max);
      if (!items.length) return;
      setup(items);
    });
  }

  /* ---------------------------------------------------------------- tile: bag button + size tray (mockup .tile__add / .tray) */
  var trayCount = 0;
  function closeTrays(except) {
    document.querySelectorAll('.pdp-tray.on').forEach(function (t) {
      if (t === except) return;
      t.classList.remove('on');
      var b = document.querySelector('[aria-controls="' + t.id + '"]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('.pdp-tile__fig')) closeTrays(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTrays(); });

  function addTray(fig, p, tile) {
    var variants = (p.variants || []).filter(function (v) { return v; });
    if (!variants.length) return;
    var sizeIndex = 0;
    (p.options || []).forEach(function (o, i) { var n = (o.name || o || '').toString().toLowerCase(); if (n === 'size') sizeIndex = i; });
    var key = 'option' + (sizeIndex + 1);
    var id = 'PdpTray-' + (++trayCount);
    var left = variants.filter(function (v) { return v.available; }).length;

    var tray = document.createElement('div');
    tray.className = 'pdp-tray';
    tray.id = id;
    tray.setAttribute('role', 'group');
    tray.setAttribute('aria-label', (cfg.trayTitle || 'Select a size') + ' — ' + p.title);
    var hd = document.createElement('div');
    hd.className = 'pdp-tray__hd';
    var hs = document.createElement('span'); hs.textContent = cfg.trayTitle || 'Select a size';
    var hb = document.createElement('b'); hb.textContent = left === variants.length ? (cfg.trayAll || 'All in stock') : left + ' of ' + variants.length + ' left';
    hd.appendChild(hs); hd.appendChild(hb);
    var row = document.createElement('div');
    row.className = 'pdp-tray__row';
    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-szbtn';
      btn.textContent = v[key] || v.title;
      if (!v.available) { btn.disabled = true; btn.setAttribute('aria-label', 'Size ' + btn.textContent + ' is sold out'); }
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var img = tile.querySelector('.pdp-tile__img--a');
        fly(img, img && img.src);
        fetch((routes.cart_add_url || root + 'cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return refreshCart();
        }).then(function () {
          setTimeout(bump, reduceMotion ? 0 : 700);
          toast((cfg.added || 'Size [size] · added to bag').replace('[size]', btn.textContent), img && img.src, p.title);
        }).catch(function () {
          toast(cfg.addFailed || 'Could not add — please try again');
        });
        closeTrays();
      });
      row.appendChild(btn);
    });
    tray.appendChild(hd); tray.appendChild(row);
    if (cfg.trayNote) { var note = document.createElement('p'); note.className = 'pdp-tray__note'; note.textContent = cfg.trayNote; tray.appendChild(note); }

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'pdp-tile__add';
    add.setAttribute('aria-expanded', 'false');
    add.setAttribute('aria-controls', id);
    add.setAttribute('aria-label', (cfg.trayTitle || 'Select a size') + ' — ' + p.title);
    add.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l1 12H5z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
    add.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var open = tray.classList.contains('on');
      closeTrays(open ? null : tray);
      tray.classList.toggle('on', !open);
      add.setAttribute('aria-expanded', String(!open));
      if (!open) { var f = tray.querySelector('.pdp-szbtn:not(:disabled)'); if (f) f.focus(); }
    });
    fig.appendChild(tray);
    fig.appendChild(add);
  }

  /* ---------------------------------------------------------------- tiles rendered in Liquid (recommendations)
     Delegated, so it also covers tiles that arrive from a fetch. */
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-pdp-tile-add]');
    if (add) {
      e.preventDefault();
      var tray = document.getElementById(add.getAttribute('aria-controls'));
      if (!tray) return;
      var isOpen = tray.classList.contains('on');
      closeTrays(isOpen ? null : tray);
      tray.classList.toggle('on', !isOpen);
      add.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) { var f = tray.querySelector('.pdp-szbtn:not(:disabled)'); if (f) f.focus(); }
      return;
    }

    var size = e.target.closest && e.target.closest('[data-pdp-tile-size]');
    if (!size || size.disabled) return;
    e.preventDefault();
    var tile = size.closest('.pdp-tile, .pdp-pair');
    var img = tile && (tile.querySelector('.pdp-tile__img--a') || tile.querySelector('img'));
    var title = tile && ((tile.querySelector('.pdp-tile__n') || tile.querySelector('.pdp-pair__n') || {}).textContent);
    fly(img, img && (img.currentSrc || img.src));
    size.disabled = true;
    fetch((routes.cart_add_url || root + 'cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(size.getAttribute('data-variant')), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return refreshCart();
    }).then(function () {
      size.disabled = false;
      closeTrays();
      setTimeout(bump, reduceMotion ? 0 : 700);
      var sizeLabel = size.getAttribute('data-label') || '';
      var msg = sizeLabel ? (cfg.added || 'Size [size] · added to bag').replace('[size]', sizeLabel) : (cfg.addedPlain || 'Added to bag');
      toast(msg, img && (img.currentSrc || img.src), title && title.trim());
    }).catch(function () {
      size.disabled = false;
      toast(cfg.addFailed || 'Could not add — please try again');
    });
  });

  /* ---------------------------------------------------------------- recommendations: fetch and swap in */
  function initRecs() {
    var sec = document.querySelector('[data-pdp-recs]');
    if (!sec || sec.dataset.pdpBound) return;
    sec.dataset.pdpBound = 'true';
    var url = sec.getAttribute('data-url');
    if (!url) return;

    function load() {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pdp-recs]');
        if (!fresh || !fresh.querySelector('.pdp-shelf')) return;
        sec.innerHTML = fresh.innerHTML;
        sec.hidden = false;
      }).catch(function () {});
    }

    // the section starts hidden, and a hidden element never triggers an
    // IntersectionObserver, so fetch straight away
    load();
  }

  /* ---------------------------------------------------------------- recently viewed */
  function initRecent() {
    var sec = document.querySelector('[data-pdp-recent]');
    if (!sec || sec.dataset.pdpBound) return;
    sec.dataset.pdpBound = 'true';

    var handle = sec.getAttribute('data-handle');
    var fmt = sec.getAttribute('data-money-format');
    ['trayTitle', 'trayAll', 'trayNote'].forEach(function (k) { if (sec.dataset[k] !== undefined) cfg[k] = sec.dataset[k]; });
    var list = sec.querySelector('[data-pdp-recent-list]');
    var seen = store.get('pdp-viewed', []);
    if (!Array.isArray(seen)) seen = [];

    var show = seen.filter(function (h) { return h && h !== handle; }).slice(0, 6);
    store.set('pdp-viewed', [handle].concat(seen.filter(function (h) { return h !== handle; })).slice(0, 12));

    sec.querySelector('[data-pdp-recent-clear]').addEventListener('click', function () {
      store.set('pdp-viewed', [handle]);
      sec.hidden = true;
    });

    if (show.length < 2) return;

    function sized(src, w) {
      if (!src) return '';
      try {
        var u = new URL(src, window.location.href);
        u.searchParams.set('width', w);
        return u.toString();
      } catch (e) { return src; }
    }

    Promise.all(show.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (products.length < 2) return;
      products.forEach(function (p) {
        var tile = document.createElement('article');
        tile.className = 'pdp-tile';

        var fig = document.createElement('div');
        fig.className = 'pdp-tile__fig';
        var imgs = (p.images || []).slice(0, 2);
        imgs.forEach(function (src, i) {
          var img = document.createElement('img');
          img.className = 'pdp-tile__img pdp-tile__img--' + (i ? 'b' : 'a');
          img.src = sized(src, 400);
          img.alt = i ? '' : p.title;
          img.loading = 'lazy';
          img.width = 400;
          img.height = 533;
          fig.appendChild(img);
        });

        addTray(fig, p, tile);

        var body = document.createElement('div');
        body.className = 'pdp-tile__b';
        var type = document.createElement('span');
        type.className = 'pdp-tile__t';
        type.textContent = p.type || '';
        var name = document.createElement('a');
        name.className = 'pdp-tile__n pdp-tile__link';
        name.href = p.url || root + 'products/' + p.handle;
        name.textContent = p.title;
        var price = document.createElement('span');
        price.className = 'pdp-tile__p';
        price.textContent = formatWhole(p.price, fmt);
        body.appendChild(type); body.appendChild(name); body.appendChild(price);

        tile.appendChild(fig); tile.appendChild(body);
        list.appendChild(tile);
      });
      sec.hidden = false;
    });
  }

  /* ---------------------------------------------------------------- buttons */
  function initButtons() {
    var wrap = document.querySelector('.main-product-template .product-form__buttons[data-pdp-add-label]');
    if (!wrap || wrap.dataset.pdpBound) return;
    wrap.dataset.pdpBound = 'true';
    var label = wrap.getAttribute('data-pdp-add-label');
    var submit = wrap.querySelector('.product-form__submit');
    var span = submit && submit.querySelector('span');

    // the theme resets this text to its own "Add To Bag" on every variant change
    if (label && span) {
      var themeLabel = window.variantStrings && window.variantStrings.addToCart;
      new MutationObserver(function () {
        if (themeLabel && span.textContent.trim() === themeLabel.trim() && themeLabel.trim() !== label) span.textContent = label;
      }).observe(span, { childList: true, characterData: true, subtree: true });
    }

    var buy = wrap.querySelector('[data-pdp-buy-now]');
    if (!buy) return;
    if (submit) new MutationObserver(function () {
      if (submit.hasAttribute('disabled')) buy.setAttribute('disabled', ''); else buy.removeAttribute('disabled');
    }).observe(submit, { attributes: true, attributeFilter: ['disabled'] });

    buy.addEventListener('click', function () {
      var form = mainForm();
      if (!form || buy.disabled) return;
      buy.disabled = true;
      buy.setAttribute('aria-busy', 'true');
      fetch((routes.cart_add_url || root + 'cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = root + 'checkout';
      }).catch(function () {
        buy.disabled = false;
        buy.removeAttribute('aria-busy');
        if (submit) submit.click(); // fall back to the theme's own add-to-cart (shows its error)
      });
    });
  }

  /* ---------------------------------------------------------------- dialogs (size guide)
     Delegated from the document so a button works no matter when it is rendered
     (section reload in the theme editor, variant change, script order). */
  var openDialog = null;

  function closeDialog() {
    if (!openDialog) return;
    var d = openDialog.dialog, btn = openDialog.button;
    d.classList.remove('on');
    document.documentElement.style.overflow = '';
    openDialog = null;
    if (btn && btn.isConnected) btn.focus();
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest && e.target.closest('[data-pdp-close]');
    if (close && openDialog && openDialog.dialog.contains(close)) { closeDialog(); return; }
    if (openDialog && e.target === openDialog.dialog) { closeDialog(); return; }

    var btn = e.target.closest && e.target.closest('[data-pdp-open]');
    if (!btn) return;
    var d = document.getElementById(btn.getAttribute('data-pdp-open'));
    if (!d) return;
    e.preventDefault();
    if (d.parentNode !== document.body) document.body.appendChild(d); // escape the section's stacking context
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    openDialog = { dialog: d, button: btn };
    requestAnimationFrame(function () {
      d.classList.add('on');
      setTimeout(function () { var c = d.querySelector('[data-pdp-close]'); if (c) c.focus(); }, 60);
    });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDialog(); });

  /* ---------------------------------------------------------------- add to bag on the product: fly, bump, toast */
  function initAddFeedback() {
    var submit = document.querySelector('.main-product-template .product--thumbnail_slider_left .product-form__submit');
    var bubble = cartButton();
    if (!submit || submit.dataset.pdpFly) return;
    submit.dataset.pdpFly = 'true';
    var pending = 0;
    submit.addEventListener('click', function () {
      if (submit.disabled) return;
      var frame = document.querySelector('.main-product-template .product__media-item.is-active img') ||
        document.querySelector('.main-product-template .product__media-list img');
      fly(frame, frame && (frame.currentSrc || frame.src));
      pending = Date.now();
    });
    if (bubble) new MutationObserver(function () {
      if (!pending || Date.now() - pending > 8000) return;
      pending = 0;
      setTimeout(bump, reduceMotion ? 0 : 200);
      var checked = document.querySelector('.main-product-template fieldset.option-name-size input:checked');
      var frame = document.querySelector('.main-product-template .product__media-item.is-active img');
      var title = (document.querySelector('.main-product-template .product__title h1') || {}).textContent;
      toast((cfg.added || 'Size [size] · added to bag').replace('[size]', checked ? checked.value : ''), frame && (frame.currentSrc || frame.src), title && title.trim());
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* ---------------------------------------------------------------- reviews: bars + filter from the Judge.me histogram */
  function initReviews() {
    var box = document.querySelector('[data-pdp-revs]');
    if (!box || box.dataset.pdpBound) return;
    box.dataset.pdpBound = 'true';

    var write = box.querySelector('[data-pdp-write-review]');
    if (write) write.addEventListener('click', function () {
      var link = box.querySelector('.jdgm-write-rev-link');
      if (link) link.click();
      var w = box.querySelector('.jdgm-widget'); if (w) w.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    var bars = box.querySelector('[data-pdp-revs-bars]');
    if (!bars) return;
    function build() {
      var rows = box.querySelectorAll('.jdgm-histogram__row[data-rating]');
      if (!rows.length) return false;
      var total = 0, data = {};
      rows.forEach(function (r) { var f = Number(r.getAttribute('data-frequency')) || 0; data[r.getAttribute('data-rating')] = { f: f, row: r }; total += f; });
      bars.textContent = '';
      [5, 4, 3, 2, 1].forEach(function (s) {
        var d = data[s] || { f: 0 };
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.disabled = !d.f;
        b.setAttribute('aria-label', 'Show ' + s + ' star reviews');
        b.innerHTML = '<span>' + s + '</span><i><u style="width:' + (total ? Math.round(d.f / total * 100) : 0) + '%"></u></i><em>' + d.f + '</em>';
        b.addEventListener('click', function () {
          var on = b.classList.contains('on');
          bars.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
          if (!on) b.classList.add('on');
          if (d.row) d.row.click(); // Judge.me filters its list from its own histogram
        });
        li.appendChild(b);
        bars.appendChild(li);
      });
      box.classList.add('pdp-revs--built');
      return true;
    }
    if (!build()) {
      var mo = new MutationObserver(function () { if (build()) mo.disconnect(); });
      mo.observe(box, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
  }

  /* ---------------------------------------------------------------- scroll reveal (mockup .rev), with a sweep so nothing is stranded */
  function initReveal() {
    if (cfg.reveal === false || reduceMotion || !('IntersectionObserver' in window)) return;
    var sel = '.pdp-sec .pdp-sec__hd, .pdp-sec .pdp-pairs > *, .pdp-sec .pdp-pairs__buy, .pdp-sec .pdp-revs, .pdp-sec .pdp-tile, .pdp-sec .pdp-ugc figure';
    document.documentElement.classList.add('pdp-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    function watch() {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.pdpRev) return;
        el.dataset.pdpRev = 'true';
        el.classList.add('pdp-rev');
        io.observe(el);
      });
    }
    function sweep() {
      var h = window.innerHeight;
      document.querySelectorAll('.pdp-rev:not(.in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < h + 140 && r.bottom > -140) el.classList.add('in');
      });
    }
    var queued = false;
    function later() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; watch(); sweep(); });
    }
    watch();
    sweep();
    // new tiles arrive from fetches (Complete the look, Recently viewed)
    document.querySelectorAll('.pdp-sec').forEach(function (sec) {
      new MutationObserver(later).observe(sec, { childList: true, subtree: true });
    });
    window.addEventListener('scroll', later, { passive: true });
  }

  /* ---------------------------------------------------------------- urgency badges
     Stock comes from the inventory Shopify already has for each variant, the cutoff
     from the merchant's own setting. Nothing here is invented or randomised. */
  function initUrgency(scope) {
    (scope || document).querySelectorAll('[data-pdp-urgency]').forEach(function (list) {
      if (list.dataset.pdpBound) return;
      list.dataset.pdpBound = 'true';

      var inv = {};
      var json = list.querySelector('script[data-pdp-urg-inv]');
      if (json) { try { inv = JSON.parse(json.textContent) || {}; } catch (e) { inv = {}; } }

      var low = list.querySelector('[data-pdp-urg-low]');
      var lowText = low && low.querySelector('[data-pdp-urg-low-text]');
      var threshold = Number(list.getAttribute('data-low-threshold')) || 0;
      var tplLow = list.getAttribute('data-low-text') || 'Only [n] left';
      var tplSold = list.getAttribute('data-sold-text') || '';

      function paintLow() {
        if (!low || !lowText) return;
        var id = currentVariantId();
        var qty = id && Object.prototype.hasOwnProperty.call(inv, id) ? inv[id] : null;
        if (qty === null || qty === undefined) { low.hidden = true; return; }
        if (qty <= 0) {
          if (!tplSold) { low.hidden = true; return; }
          lowText.textContent = tplSold;
          low.hidden = false;
          return;
        }
        if (qty > threshold) { low.hidden = true; return; }
        lowText.textContent = tplLow.replace('[n]', qty);
        low.hidden = false;
      }

      var form = mainForm();
      if (form) form.addEventListener('change', function () { setTimeout(paintLow, 60); });
      document.addEventListener('variant:change', function () { setTimeout(paintLow, 60); });
      paintLow();

      var cut = list.querySelector('[data-pdp-urg-cutoff]');
      if (!cut) return;
      var cutText = cut.querySelector('[data-pdp-urg-cutoff-text]');
      var minsLeft = Number(cut.getAttribute('data-mins-left')) || 0;
      if (!cutText || minsLeft <= 0) return;
      var started = Date.now();
      var tplCut = cut.getAttribute('data-text') || 'Order within [time]';
      var tplAfter = cut.getAttribute('data-after') || '';

      function paintCutoff() {
        var left = minsLeft - Math.floor((Date.now() - started) / 60000);
        if (left <= 0) {
          if (tplAfter) { cutText.textContent = tplAfter; cut.className = 'pdp-urg__b pdp-urg__b--calm'; }
          else cut.hidden = true;
          clearInterval(timer);
          return;
        }
        var h = Math.floor(left / 60);
        var m = left % 60;
        var pretty = h > 0 ? h + 'h ' + (m < 10 ? '0' + m : m) + 'm' : m + ' min';
        cutText.textContent = tplCut.replace('[time]', pretty);
        // the last hour is the one worth flagging
        cut.className = 'pdp-urg__b ' + (left <= 60 ? 'pdp-urg__b--hot' : 'pdp-urg__b--calm');
      }
      var timer = setInterval(paintCutoff, 30000);
      paintCutoff();
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot(scope) {
    initSizeNotes(scope);
    initUrgency(scope);
    initButtons();
    initAddFeedback();
    initReviews();
    initRecs();
    initReveal();
    initPin(scope);
    initStick();
    initLook();
    initRecent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
